import React from 'react';
import { OrderNumberComponent } from '../../../components/columns/order-number';

import { messages } from './messages';

export const OrderNumber = {
  getMessageDescriptor: () => messages.orderNumber,
  id: 'order-number',

  render: (data, { isExpanded = false, isFirstOfType = true, isDisabled = false, isFirstRow = true } = {}) => {
    if (!isFirstOfType) {
      return null;
    }

    return (
      <OrderNumberComponent
        fulfillmentPlanId={data.id}
        isDisabled={isDisabled}
        isExpanded={isExpanded}
        isFirstRow={isFirstRow}
        salesOrderId={data.salesOrderId}
      />
    );
  },
};
